import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

// A select rendered inside a table cell has to read as plain table text until it is focused, so the input is
// pulled up into the row's text baseline and given the row's font size and colour.
export const useInlineSelectCellStyles = () => {
    const theme = useTheme();

    return createSxStyles({
        select: {
            "& .MuiAutocomplete-root .MuiInputBase-input": {
                marginBottom: -1,
                fontSize: theme.typography.pxToRem(12),
                color: theme.palette.primary.dark,
                WebkitTextFillColor: theme.palette.primary.dark,
            },
        },
    });
};
